(function () {
  'use strict';

  var EMAIL_STORAGE_KEY = 'trsStockNotifyEmail:v1';
  var SUBSCRIPTIONS_STORAGE_KEY = 'trsStockNotifySubscriptions:v1';
  var STORAGE_LIFETIME_MS = 90 * 24 * 60 * 60 * 1000;

  function storageGet(key) {
    try { return window.localStorage ? window.localStorage.getItem(key) : null; } catch (error) { return null; }
  }

  function storageSet(key, value) {
    try { if (window.localStorage) window.localStorage.setItem(key, value); } catch (error) { /* Storage is optional. */ }
  }

  function storageRemove(key) {
    try { if (window.localStorage) window.localStorage.removeItem(key); } catch (error) { /* Storage is optional. */ }
  }

  function parseStoredObject(key) {
    var raw = storageGet(key);
    if (!raw) return null;
    try {
      var value = JSON.parse(raw);
      if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Invalid stored value.');
      return value;
    } catch (error) {
      storageRemove(key);
      return null;
    }
  }

  function normaliseEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function rememberEmail(value) {
    var normalised = normaliseEmail(value);
    if (!normalised || normalised.indexOf('@') < 1) return;
    storageSet(EMAIL_STORAGE_KEY, JSON.stringify({
      email: normalised,
      storedAt: Date.now(),
      expiresAt: Date.now() + STORAGE_LIFETIME_MS
    }));
  }

  function rememberedEmail() {
    var record = parseStoredObject(EMAIL_STORAGE_KEY);
    if (!record) return '';
    if (typeof record.email !== 'string' || record.email.indexOf('@') < 1 || !Number(record.expiresAt) || Number(record.expiresAt) <= Date.now()) {
      storageRemove(EMAIL_STORAGE_KEY);
      return '';
    }
    return normaliseEmail(record.email);
  }

  function isSafeCancelUrl(value) {
    return typeof value === 'string' && /^\/apps\/stock-notify\/cancel\?/.test(value);
  }

  function readSubscriptions() {
    var stored = parseStoredObject(SUBSCRIPTIONS_STORAGE_KEY);
    var subscriptions = {};
    var changed = false;
    if (!stored) return subscriptions;
    Object.keys(stored).forEach(function (variantId) {
      var record = stored[variantId];
      if (!/^[1-9][0-9]*$/.test(variantId) || !record || typeof record !== 'object' || String(record.variantId || '') !== variantId || !isSafeCancelUrl(record.cancelUrl) || !Number(record.expiresAt) || Number(record.expiresAt) <= Date.now()) {
        changed = true;
        return;
      }
      subscriptions[variantId] = {
        variantId: variantId,
        cancelUrl: record.cancelUrl,
        storedAt: Number(record.storedAt) || 0,
        expiresAt: Number(record.expiresAt)
      };
    });
    if (changed) storageSet(SUBSCRIPTIONS_STORAGE_KEY, JSON.stringify(subscriptions));
    return subscriptions;
  }

  function rememberedSubscription(variantId) {
    return readSubscriptions()[String(variantId || '')] || null;
  }

  function rememberSubscription(variantId, cancelUrl) {
    variantId = String(variantId || '');
    if (!/^[1-9][0-9]*$/.test(variantId) || !isSafeCancelUrl(cancelUrl)) return;
    var subscriptions = readSubscriptions();
    subscriptions[variantId] = {
      variantId: variantId,
      cancelUrl: cancelUrl,
      storedAt: Date.now(),
      expiresAt: Date.now() + STORAGE_LIFETIME_MS
    };
    storageSet(SUBSCRIPTIONS_STORAGE_KEY, JSON.stringify(subscriptions));
  }

  function forgetSubscription(variantId) {
    var subscriptions = readSubscriptions();
    variantId = String(variantId || '');
    if (!Object.prototype.hasOwnProperty.call(subscriptions, variantId)) return;
    delete subscriptions[variantId];
    storageSet(SUBSCRIPTIONS_STORAGE_KEY, JSON.stringify(subscriptions));
  }

  function initialise(root) {
    if (!root || root.getAttribute('data-trs-stock-notification-ready') === '1') return;
    root.setAttribute('data-trs-stock-notification-ready', '1');

    var form = root.querySelector('[data-trs-stock-notification-form]');
    var status = root.querySelector('[data-trs-stock-notification-status]');
    var cancel = root.querySelector('[data-trs-stock-notification-cancel]');
    var submit = form ? form.querySelector('button[type="submit"]') : null;
    var email = form ? form.querySelector('input[name="email"]') : null;
    var variantsNode = root.querySelector('[data-trs-stock-notification-variants]');
    var variants = {};
    var selectedVariantId = String(root.getAttribute('data-selected-variant-id') || '');

    try {
      (JSON.parse(variantsNode ? variantsNode.textContent : '[]') || []).forEach(function (variant) {
        variants[String(variant.id)] = variant;
      });
    } catch (error) {
      root.hidden = true;
      return;
    }

    function prefillRememberedEmail() {
      var savedEmail = rememberedEmail();
      if (email && !email.value && savedEmail) email.value = savedEmail;
    }

    function resetMessage() {
      status.textContent = '';
      status.classList.remove('isError');
      cancel.hidden = true;
      cancel.disabled = false;
      cancel.textContent = 'Cancel notification';
      if (form) form.hidden = false;
      prefillRememberedEmail();
    }

    function showSubscribed(record, message) {
      status.classList.remove('isError');
      status.textContent = message || '✓ You’re on the list. We’ll email you when this item is back in stock.';
      if (form) form.hidden = true;
      cancel.hidden = !record || !record.cancelUrl;
    }

    function displayVariant(variant) {
      selectedVariantId = variant && variant.id ? String(variant.id) : '';
      root.setAttribute('data-selected-variant-id', selectedVariantId);
      resetMessage();
      root.hidden = !selectedVariantId || !variant || variant.available !== false;
      if (!root.hidden) {
        var localSubscription = rememberedSubscription(selectedVariantId);
        if (localSubscription) showSubscribed(localSubscription);
      }
    }

    function currentVariant() {
      return variants[selectedVariantId] || null;
    }

    if (selectedVariantId) displayVariant(currentVariant());
    else root.hidden = true;

    document.addEventListener('trs:variant:change', function (event) {
      var variant = event.detail && event.detail.variant ? event.detail.variant : null;
      if (!variant || !variants[String(variant.id)]) return;
      variants[String(variant.id)].available = variant.available === true;
      displayVariant(variants[String(variant.id)]);
    });

    if (!form) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var variant = currentVariant();
      if (!variant || variant.available !== false) {
        displayVariant(variant);
        return;
      }
      if (!email || !email.checkValidity()) {
        if (email) email.reportValidity();
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Adding…';
      status.classList.remove('isError');
      status.textContent = 'Checking this option…';
      var honeypot = form.querySelector('input[name="website"]');
      var submittedVariantId = selectedVariantId;
      var submittedEmail = normaliseEmail(email.value);
      fetch(root.getAttribute('data-subscribe-url'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          email: email.value,
          variant_id: submittedVariantId,
          product_id: String(root.getAttribute('data-product-id') || ''),
          website: honeypot ? honeypot.value : ''
        })
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          return { ok: response.ok, data: data };
        });
      }).then(function (result) {
        if (!result.ok || result.data.ok !== true) throw new Error(result.data.error || 'We couldn’t save that notification. Please try again.');
        if (result.data.status === 'created' || result.data.status === 'duplicate') rememberEmail(submittedEmail);
        if (result.data.status === 'created' && result.data.cancel_url) rememberSubscription(submittedVariantId, result.data.cancel_url);
        if (selectedVariantId !== submittedVariantId) {
          displayVariant(currentVariant());
          return;
        }
        if (result.data.status === 'available') {
          form.hidden = true;
          status.textContent = result.data.message || 'This option is available now. Refresh the page to purchase it.';
          return;
        }
        var localSubscription = rememberedSubscription(submittedVariantId);
        showSubscribed(localSubscription, result.data.message || (result.data.status === 'duplicate'
          ? '✓ You’re already on the list for this item.'
          : '✓ You’re on the list. We’ll email you when this item is back in stock.'));
      }).catch(function (error) {
        status.classList.add('isError');
        status.textContent = error.message || 'We couldn’t save that notification. Please try again.';
      }).then(function () {
        submit.disabled = false;
        submit.textContent = 'Notify me';
      });
    });

    cancel.addEventListener('click', function (event) {
      event.preventDefault();
      var cancellationVariantId = selectedVariantId;
      var subscription = rememberedSubscription(cancellationVariantId);
      if (!subscription) {
        displayVariant(currentVariant());
        return;
      }
      cancel.disabled = true;
      cancel.textContent = 'Cancelling…';
      status.classList.remove('isError');
      status.textContent = 'Cancelling your notification…';
      var cancelFetchUrl = subscription.cancelUrl + (subscription.cancelUrl.indexOf('?') === -1 ? '?' : '&') + 'response=json';
      fetch(cancelFetchUrl, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'application/json' }
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          return { ok: response.ok, data: data };
        });
      }).then(function (result) {
        if (!result.ok || result.data.ok !== true || result.data.status !== 'cancelled') throw new Error(result.data.error || 'We couldn’t cancel that notification. Please try again.');
        forgetSubscription(cancellationVariantId);
        if (selectedVariantId !== cancellationVariantId) {
          displayVariant(currentVariant());
          return;
        }
        cancel.hidden = true;
        if (form) form.hidden = false;
        prefillRememberedEmail();
        status.classList.remove('isError');
        status.textContent = result.data.message || 'Your stock notification has been cancelled.';
      }).catch(function (error) {
        if (selectedVariantId !== cancellationVariantId) {
          displayVariant(currentVariant());
          return;
        }
        status.classList.add('isError');
        status.textContent = error.message || 'We couldn’t cancel that notification. Please try again.';
      }).then(function () {
        cancel.disabled = false;
        cancel.textContent = 'Cancel notification';
      });
    });
  }

  function initialiseAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-trs-stock-notification]'), initialise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
  else initialiseAll();
}());
